/*
 * Copyright (c) 2023 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { memo } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Divider, Theme, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { MainBtn, RedMainBtn } from '../StyledComponents/MainBtn';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        modalWrapper: {
            padding: theme.spacing(2),
        },
        dialogTitle: {
            textAlign: 'center',
        },
        dataLine: {
            display: 'flex',
            flexDirection: 'row',
        },
        value: {
            fontWeight: 600,
            textAlign: 'center',
            margin: theme.spacing(2, 0),
            color: theme.palette.text.secondary,
        },
        actions: {
            marginTop: theme.spacing(2),
            justifyContent: 'center',
        },
        button: {
            padding: theme.spacing(0.8, 1, 0.5, 1),
            minWidth: 150,
        },
        dialogContent: {
            margin: theme.spacing(0, 4.5),
        },
    }),
);

interface ConfirmDeleteFilesModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    numberOfFiles: number;
}

const ConfirmDeleteFilesModal = (props: ConfirmDeleteFilesModalProps) => {
    const { onConfirm, onClose, isOpen, numberOfFiles } = props;
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <Dialog open={isOpen} onClose={onClose}>
            <div className={classes.modalWrapper}>
                <DialogTitle className={classes.dialogTitle}>{t('app.confirmDeleteFiles')}</DialogTitle>
                <DialogContent className={classes.dialogContent}>
                    <Divider />

                    <Typography className={classes.value} variant={'body1'}>
                        {t('app.numberOfSelectedFiles', { number: numberOfFiles })}
                    </Typography>

                    <Divider />
                </DialogContent>

                <DialogActions className={classes.actions}>
                    <MainBtn className={classes.button} variant="contained" onClick={onClose}>
                        {t('app.no')}
                    </MainBtn>
                    <RedMainBtn
                        className={classes.button}
                        variant="contained"
                        onClick={() => {
                            onConfirm();
                            onClose();
                        }}
                    >
                        {t('app.yes')}
                    </RedMainBtn>
                </DialogActions>
            </div>
        </Dialog>
    );
};

export default memo(ConfirmDeleteFilesModal);
